import React from "react";
import PropTypes from "prop-types";
import { Grid, Loader, Dimmer, Ref } from "semantic-ui-react";
import { Header, PlaceHolder } from "../../components/common";
import { paypalImgEng, paypalImgHeb } from "../../constants/constants";
import styles from "./styles.less";
import scrollToComponent from "react-scroll-to-component";

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentIframeLoaded: false
    };
  }
  componentDidMount() {
    const { getAnalyticsPlaceHolders } = this.props;
    window.addEventListener("message", this.recieveWindowMessage);
    if (this.wrapperRef) {
      scrollToComponent(this.wrapperRef, 10);
    }
    getAnalyticsPlaceHolders && getAnalyticsPlaceHolders();
  }

  componentDidUpdate(prevProps) {
    const { payment } = this.props;
    if (payment.URL && !prevProps.payment.URL) {
      if (this.wrapperRef) {
        scrollToComponent(this.wrapperRef, 10);
      }
    }
  }

  componentWillUnmount() {
    const { clearAnalyticsPlaceHolders } = this.props;
    clearAnalyticsPlaceHolders && clearAnalyticsPlaceHolders();
    window.removeEventListener("message", this.recieveWindowMessage);
  }

  recieveWindowMessage = event => {
    if (
      event.origin !== "https://gateway20.pelecard.biz" &&
      event.origin !== "http://localhost:8888" &&
      event.origin !== "https://bookingresults.com" &&
      event.origin !== "https://partner.webbnb.com" &&
      event.origin !== "https://vm-build"
    ) {
      return;
    }
    if (event.data === "___pleaseReloadSilverbytePaymentIframe") {
      this.reloadPaymentIframe();
    }
  };

  wrapperRef = React.createRef();
  paymentIframeRef = React.createRef();

  setRef = node => (this.wrapperRef = node);
  setPaymentIframeRef = node => (this.paymentIframeRef = node);

  renderNoPayment = () => {
    const { titles, continueToConfirmation } = this.props;
    return (
      <Grid.Row className={styles.mainHeaderWrapper}>
        <Grid.Column width={16}>
          <div className={styles.contiuneWrapper}>
            <div
              className={styles.contiuneButton}
              onClick={continueToConfirmation}
              onKeyDown={continueToConfirmation}
              role="button"
              tabIndex="0"
            >
              {titles.Continue}
            </div>
          </div>
        </Grid.Column>
      </Grid.Row>
    );
  };

  goToPayPalProxy = () => {
    const { payment } = this.props;
    window.open(payment.PaypallUrl, "_blank");
  };

  reloadPaymentIframe = () => {
    const { resetPayment } = this.props;
    resetPayment();
  };

  renderHeader = () => {
    const { titles, isRtl, placeHolders } = this.props;
    return (
      <Grid.Column width={16}>
        <Header
          text={titles.EnterPaymentData + " :"}
          isRtl={isRtl}
          noSidePadding={true}
        />
        <Header
          text={titles.CreditCardIsForSaftlyOnly}
          isRtl={isRtl}
          subtitle
          noSidePadding={true}
        />
        <PlaceHolder
          placeHolders={placeHolders}
          component={"RegistrationPage"}
          location={"PaymentHeaderBottom"}
          disablePreLine={true}
        />
      </Grid.Column>
    );
  };

  updateIframeLoaded = () => {
    this.setState({
      paymentIframeLoaded: true
    });
  };

  renderPayment = () => {
    const {
      payment,
      titles,
      transactionId,
      token,
      domainUrl,
      lang
    } = this.props;
    const { paymentIframeLoaded } = this.state;
    const finishedPayment =
      (transactionId != null && transactionId.length > 0) ||
      (token != null && token.length > 0);
    const paypalImgUrlBase = domainUrl.substring(
      0,
      domainUrl.indexOf("actionUrl")
    );
    const paypalImageUrl =
      paypalImgUrlBase + (lang == "heb" ? paypalImgHeb : paypalImgEng);
    return (
      <Grid.Row>
        {this.renderHeader()}
        <Grid.Column width={16}>
          {payment.IsPayPal && (
            <div className={styles.paymentWrapper}>
              <input
                onClick={this.goToPayPalProxy}
                onKeyDown={this.goToPayPalProxy}
                tabIndex="0"
                type="image"
                name="submit"
                alt={titles.PayWithPayPal}
                src={paypalImageUrl}
              />
            </div>
          )}
          {!payment.IsPayPal &&
            !paymentIframeLoaded && (
              <Grid.Column width={16}>
                <Dimmer className={styles.loaderWrapper} active inverted>
                  <Loader size="huge" inverted>
                    {titles.PreparingPaymentPage}...
                  </Loader>
                </Dimmer>
              </Grid.Column>
            )}
          {payment.URL &&
            !finishedPayment && (
              <React.Fragment>
                <iframe
                  ref={this.setPaymentIframeRef}
                  key={1}
                  id="payment-iframe"
                  className={styles.paymentIframe}
                  src={payment && payment.URL}
                  width="100%"
                  height="520px"
                  title="payment-iframe"
                  frameBorder="0"
                  scrolling="no"
                  onLoad={this.updateIframeLoaded}
                  //allowTransparency="true"
                />
                <input
                  type="hidden"
                  id="payment-iframe-reloader"
                  onClick={this.reloadPaymentIframe}
                />
              </React.Fragment>
            )}
        </Grid.Column>
      </Grid.Row>
    );
  };

  paymentError = () => {
    const { titles } = this.props;
    return (
      <Grid.Row>
        {this.renderHeader()}
        <Grid.Column width={16}>
          <div className={styles.error}>{titles.ErrorOccourred}</div>
        </Grid.Column>
      </Grid.Row>
    );
  };

  renderPaymentProcess() {
    const {
      payment,
      titles,
      isFetchingPaymentData,
      paymentUrlRequestStatus
    } = this.props;
    const isNoPayment = payment && payment.URL === "nopayment";
    return (
      <Grid className={styles.paymentWrapper}>
        {isFetchingPaymentData ? (
          <Grid.Column width={16}>
            <Dimmer className={styles.loaderWrapper} active inverted>
              <Loader size="huge" inverted>
                {titles.PreparingPaymentPage}...
              </Loader>
            </Dimmer>
          </Grid.Column>
        ) : paymentUrlRequestStatus ? (
          isNoPayment ? (
            this.renderNoPayment()
          ) : (
            this.renderPayment()
          )
        ) : (
          this.paymentError()
        )}
      </Grid>
    );
  }

  renderLoader = () => {
    const { renderLoader } = this.props;
    return <Grid>{renderLoader(true)}</Grid>;
  };

  render() {
    return <Ref innerRef={this.setRef}>{this.renderPaymentProcess()}</Ref>;
  }
}

Payment.propTypes = {
  titles: PropTypes.object,
  isRtl: PropTypes.bool,
  payment: PropTypes.object,
  transactionId: PropTypes.string,
  token: PropTypes.string,
  renderLoader: PropTypes.func,
  continueToConfirmation: PropTypes.func,
  isFetchingPaymentData: PropTypes.bool,
  paymentUrlRequestStatus: PropTypes.bool,
  resetPayment: PropTypes.func,
  placeHolders: PropTypes.array,
  getAnalyticsPlaceHolders: PropTypes.func,
  clearAnalyticsPlaceHolders: PropTypes.func,
  domainUrl: PropTypes.string,
  lang: PropTypes.string
};

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Payment/Payment.js